<!-- @format -->
@if (shouldShowCarousel()) {
	<div
		id="social-content-images-carousel"
		class="hmf-mb-xl hmf-mx-s">
		<hmf-carousel
			[title]="'Seen on Social'"
			[subtitle]="'Tag @dickssportinggoods on Instagram for a chance to be featured'">
			@for (media of socialContentImages(); let index = $index; track media?.id) {
				@if (media && media.original) {
					<div
						class="hmf-position-relative"
						[class.social-image]="!isMobileSize()">
						<button
							class="button-image-container hmf-p-0 hmf-sharp-radius"
							(click)="openModal(index)">
							<img
								#imgSocial
								[alt]="'Social Content from @dickssportinggoods ' + (index + 1)"
								[src]="media.original + '/sc/300x300'"
								[priority]="false"
								[attr.loading]="'lazy'"
								[width]="isMobileSize() ? '250' : '272'"
								[height]="isMobileSize() ? '250' : '272'"
								fill />
						</button>
					</div>
				}
			}
		</hmf-carousel>
	</div>
}
